import { Mail, Phone, Pencil } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function ContactCard({ contact, onEdit }) {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/contact/${contact.id}`);
  };

  const fullName = `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || 'Unnamed Contact';
  const relationship = contact?.relationship || '';
  const isTenant = relationship.toLowerCase() === 'tenant';

  return (
    <div
      onClick={handleCardClick}
      className="flex justify-between items-center gap-x-6 py-5 px-4 rounded-xl glass bg-white/5 border border-white/10 text-white hover:bg-[#23272f]/60 transition mb-4 cursor-pointer"
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleCardClick();
      }}
    >
      <div className="flex flex-col min-w-0 flex-1">
        <p className="text-base font-semibold text-white">{fullName}</p>

        {relationship && (
          <div className="mt-1 flex items-center gap-2">
            <span className="text-xs text-gray-400">{relationship}</span>

            {isTenant && (
              <span className="rounded-full border border-[#AF9B8A]/40 bg-[#AF9B8A]/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#AF9B8A]">
                Tenant
              </span>
            )}
          </div>
        )}
      </div>

      <div className="flex gap-4 items-center" onClick={(e) => e.stopPropagation()}>
        {contact.email && (
          <a
            href={`mailto:${contact.email}`}
            className="hover:text-[#AF9B8A] transition"
            aria-label={`Email ${fullName}`}
          >
            <Mail className="w-5 h-5" />
          </a>
        )}

        {contact.phone && (
          <a
            href={`tel:${contact.phone}`}
            className="hover:text-[#AF9B8A] transition"
            aria-label={`Call ${fullName}`}
          >
            <Phone className="w-5 h-5" />
          </a>
        )}

        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit && onEdit(contact);
          }}
          className="hover:text-[#AF9B8A] transition"
          aria-label={`Edit ${fullName}`}
        >
          <Pencil className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}

export default ContactCard;